module.exports = __webpack_public_path__ + "img/Oscar Pet.b25e7dc0.svg";